module.exports = __webpack_public_path__ + "static/media/thirdImage.0189b3cd.psd";